<template>
<div :class=div_classes >
    <label v-for="item in items" :key="item.value" 
            :class="value === item.value ? 'active' : ''" >
        <input type="radio" @change="change"
        :name="name"
        v-model="value" 
        :value="item.value"
          />
          {{ item.label }} 
    </label>
</div>
</template>

<script>
export default {
    name: 'RadioGroupPills',
    data () {
        return {
        value: "",
        }
    },
    created : function(){
        this.value = this.default_val
    },
    props: {
        default_val : String,
        div_classes : String,
        name : String,
        items : {
            type: Array,
            default: function () {
                return []
            }
        }
    },
    watch: {
        default_val : function(){
            this.value = this.default_val
        }
    },
    methods : {
        change : function(){
            this.$emit('input', this.value)
        }
    }
}
</script>

<style scoped>

div > :first-child {
    border-radius: .8em 0  0 .8em ;
}

div > :last-child {
    border-radius: 0 .8em .8em 0 ;
}

div {
    margin: .1em;
    smax-width:400px;
    height: 3em;
}
label.active:hover, label.active {
    background-color: rgba(38,85,139,1);
    color: #fff;
}
label > input {
    display: none;
}
label {
    float: left;
    background-color: #fff;
    height: 1.5em;
    padding: .5em 1em .2em 1em;
    border: 1px solid #fff;
    margin: 1px;
    border-radius: .2em;
}

label:hover {
    background-color: #888
}
 
</style>
